import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var OutModes = /*#__PURE__*/function () {
  function OutModes() {
    _classCallCheck(this, OutModes);
    this.default = "out";
  }
  _createClass(OutModes, [{
    key: "load",
    value: function load(data) {
      var _a, _b, _c, _d;
      if (!data) {
        return;
      }
      if (data.default !== undefined) {
        this.default = data.default;
      }
      this.bottom = (_a = data.bottom) !== null && _a !== void 0 ? _a : data.default;
      this.left = (_b = data.left) !== null && _b !== void 0 ? _b : data.default;
      this.right = (_c = data.right) !== null && _c !== void 0 ? _c : data.default;
      this.top = (_d = data.top) !== null && _d !== void 0 ? _d : data.default;
    }
  }]);
  return OutModes;
}();